import { useQuery } from '@tanstack/react-query';
import { get } from '../api/api';
import { API_URLS } from '../constants/apiUrl';
import { QueryParamObject, toQueryString } from '../constants/utilityFunctions';
import { ICustomer } from '../interface/customer';
import { Entities } from '../interface/common';

interface IFetchCustomerById {
  id?: string;
  relations?: string[];
  withFavoriteInformation?: boolean;
  fields?: string[];
}
export const useFetchCustomerById = (params: IFetchCustomerById) => {
  const { id, ...queryParams } = params;
  const queryString = Object.keys(queryParams)?.length
    ? toQueryString(queryParams as QueryParamObject)
    : null;
  const customerUrl = `${API_URLS.CUSTOMER_LIST}/${id}`;
  const url = queryString ? `${customerUrl}?${queryString}` : customerUrl;
  const query = useQuery<ICustomer, Error>({
    queryKey: ['customer-details', id],
    queryFn: async () => {
      const response = await get(
        url,
        {},
        {
          headers: {
            entity: Entities.CUSTOMER,
          },
        },
      );
      return response;
    },
    enabled: !!id,
  });

  return query;
};
